export default "__VITE_ASSET__b0b5c400__"